import TwitterShareIcon from '~/assets/icons/Twitter';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';

import Tracked from '../Tracked';

const ShareToTwitter = ({
  position,
  text
}: {
  position: number;
  text: string;
}) => {
  const href = `https://twitter.com/intent/tweet?text=${text}`;
  const fireShareLink = useNavigationLinkInteraction('share');

  function onClick() {
    fireShareLink(href, position);

    window.open(
      href,
      'popUpWindow',
      'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes'
    );
  }

  return (
    <Tracked.Button
      variant="none"
      onClick={onClick}
      className="cursor-pointer"
      name="SHARE_TO_TWITTER"
      pagePosition="Body"
    >
      <TwitterShareIcon height="24" width="24" fill="black" />
    </Tracked.Button>
  );
};

export default ShareToTwitter;
